<div class="amplifier">
  <!-- Intentionally empty -->
</div>

<cw-icon class="icon" [icon]="iconsMap[type()]" font="cortex" size="sm" />
<div class="wrapper">
  <div class="snack-title">{{ title() }}</div>
  <div class="snack-badge">
    <ng-content select="[badge]" />
  </div>
  <div class="snack-text" [innerHTML]="text() | safeHtml"></div>
  <ng-content select="[info]" />
  <div class="snack-timestamp">
    {{ timestamp() }}
  </div>
</div>

@if (closeable()) {
  <cw-action-icon (click)="closed.emit()" icon="close" font="cortex" />
}
